import PropTypes from 'prop-types';

import { TrlFormattedMessagePlain } from '»utils/i18n';

import { Operation, OperationLabel } from './TrlOperationType.styles';

export const TrlOperationType = ({ side, label }) => {
  return (
    <Operation side={side}>
      <OperationLabel side={side}>
        {TrlFormattedMessagePlain({ id: label })}
      </OperationLabel>
    </Operation>
  );
};

TrlOperationType.propTypes = {
  side: PropTypes.string,
  label: PropTypes.string.isRequired,
};
